import { CancelToken } from "axios";
import { ActionContext } from "vuex";

import IState from "@/interfaces/IState";
import { extractFullData } from "@/libs/backend/apimapper";

export default async function fetchPartners(
  context: ActionContext<IState, IState>,
  { query, cancelToken }: { query: string; cancelToken: CancelToken }
) {
  const campaigns = await context.dispatch(
    "backendTalker",
    {
      request: "partners_list",
      query,
      cancelToken,
      showErrorNotify: false,
    },
    { root: true }
  );

  if (!campaigns || campaigns.status !== 200) {
    return Promise.reject(null);
  }

  return extractFullData(campaigns.data);
}
